import React, { useEffect } from "react";
import { Grid } from "@material-ui/core";
import Controls from "../../../controls/Controls";
import { useForm, Form } from "../../../controls/useForm";
import { ToastContainer } from "react-toastify";
import { request } from "../../../../api/Service";
import { store } from "../../../../redux-store/store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getErrorMessage } from "../../../utils/errorHandler";
import { connect } from "react-redux";
import SelectSku from "../../../controls/SelectSku";

const initialFValues = {
  fromlocationId: 0,
  toLocationId: 0,
  quantity: 0,
  sku: "",
  remark: "",
  mode: "",
};
var get_product = () => {};

function AddWareHouseTransfer(props) {
  const {
    addOrEdit,
    addInventory,
    recordForEdit,
    products,
    locations,
    productList,
    locationDropDown,
    setOpenPopup,
  } = props;
  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("remark" in fieldValues)
      temp.remark = fieldValues.remark ? "" : "This field is required.";
    if ("quantity" in fieldValues)
      temp.quantity = fieldValues.quantity ? "" : "This field is required.";
    if ("sku" in fieldValues)
      temp.sku = fieldValues.sku ? "" : "This sku is required.";
    if ("fromlocationId" in fieldValues)
      temp.fromlocationId =
        fieldValues.fromlocationId > 0 ? "" : "Select From Location";
    if ("toLocationId" in fieldValues)
      temp.toLocationId =
        fieldValues.toLocationId > 0 ? "" : "Select To Location";
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate, get_product);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      store.dispatch({ type: "DISPLAY_LOADER" });
      request("post", values, `warehouse-transfer`)
        .then((data) => {
          store.dispatch({ type: "DISPLAY_LOADER" });
          store.dispatch({ type: "LOAD_INVENTORY_COUNT", payload: {} });
          setOpenPopup(false);
        })
        .catch((e) => {
          const errorMessage = getErrorMessage(e.response);
          toast.error(errorMessage);
        });
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit]);

  return (
    <Form onSubmit={handleSubmit}>
      <ToastContainer />
      <Grid container>
        <Grid item xs={6}>
          <div className="relative">
            <SelectSku
              name="sku"
              label="sku"
              value={values.sku || ""}
              onChange={handleInputChange}
              options={productList}
              error={errors.sku}
            />
            <i className="fas fa-barcode fa-2x absolute right-24 bottom-5"></i>
          </div>

          <Controls.Input
            label="Quantity"
            name="quantity"
            value={values.quantity || ""}
            onChange={handleInputChange}
            error={errors.quantity}
          />
          <Controls.Checkbox label="Same Location" />
        </Grid>
        <Grid item xs={6}>
          <Controls.Select
            name="fromlocationId"
            label="From Storage (Location)"
            value={values.fromlocationId || ""}
            onChange={handleInputChange}
            options={locationDropDown}
            error={errors.fromlocationId}
          />
          <Controls.Select
            name="toLocationId"
            label="To Storage (Location)"
            value={values.toLocationId || ""}
            onChange={handleInputChange}
            options={locationDropDown}
            error={errors.toLocationId}
          />
          <Controls.Input
            name="remark"
            label="Remark"
            value={values.remark || ""}
            onChange={handleInputChange}
            error={errors.remark}
          />
          <div>
            <Controls.Button type="submit" text="Submit" />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}

const mapStateToProps = (state) => {
  return {
    productList: state.productReducer.productList,
  };
};

export default connect(mapStateToProps)(AddWareHouseTransfer);
